import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

export const PeritajesEuModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
  const handleContactClick = () => {
    onClose();
    onOpenContactModal('Consulta sobre Peritajes.EU');
  };

  return (
    <ModalBase 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Peritajes.EU - Informes de Expertos"
      headerClassName="bg-yellow-100 border-yellow-200"
      titleClassName="text-yellow-800"
    >
      <p className="mb-6">
        En un proceso legal, una prueba técnica sólida puede marcar la diferencia entre ganar y perder. En Peritajes.EU, nuestro equipo de peritos cualificados proporciona informes objetivos y rigurosos que aportan la evidencia crucial para tu caso, ya sea en una negociación o en un juicio.
      </p>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestros Servicios Periciales</h3>
        <p>Ofrecemos una amplia gama de informes técnicos especializados en el sector de la automoción y la circulación:</p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li><strong>Reconstrucción de Accidentes de Tráfico:</strong> Analizamos las evidencias (huellas, deformaciones, testimonios) para determinar las causas y responsabilidades de una colisión.</li>
          <li><strong>Valoración de Daños Materiales:</strong> Tasamos con precisión los daños de un vehículo para reclamaciones a seguros o terceros.</li>
          <li><strong>Análisis de Averías Mecánicas:</strong> Investigamos el origen de fallos mecánicos para determinar si se deben a un defecto de fabricación, un mal mantenimiento o un vicio oculto.</li>
          <li><strong>Informes Biomecánicos:</strong> Estudiamos la compatibilidad entre las lesiones de los ocupantes y la dinámica del accidente.</li>
          <li><strong>Verificación de Pruebas:</strong> Realizamos contra-análisis sobre el funcionamiento de cinemómetros (radares) y etilómetros.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestro Proceso de Trabajo</h3>
        <ol className="list-decimal list-inside mt-2 space-y-2">
          <li><strong>Contacto y Análisis del Caso:</strong> Evaluamos tus necesidades y la viabilidad de la prueba pericial.</li>
          <li><strong>Investigación Exhaustiva:</strong> Recopilamos y analizamos toda la documentación, inspeccionamos vehículos y lugares de los hechos.</li>
          <li><strong>Elaboración del Informe Pericial:</strong> Redactamos un documento claro, conciso y fundamentado, con conclusiones contundentes y comprensibles.</li>
          <li><strong>Ratificación en Juicio:</strong> Si es necesario, nuestros peritos defienden el informe ante los tribunales con solvencia y profesionalidad.</li>
        </ol>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-gray-700 mb-3">¿Por Qué Confiar en Peritajes.EU?</h3>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li><strong>Expertos Cualificados:</strong> Peritos titulados y con amplia experiencia en el sector.</li>
          <li><strong>Metodología Científica:</strong> Utilizamos las técnicas más avanzadas para garantizar la objetividad y el rigor de nuestros análisis.</li>
          <li><strong>Validez Legal Europea:</strong> Nuestros informes cumplen con todos los requisitos para ser admitidos como prueba en los juzgados de toda Europa.</li>
          <li><strong>Independencia e Imparcialidad:</strong> Nuestro único compromiso es con la verdad técnica.</li>
        </ul>
      </section>

      <div className="mt-8 pt-6 border-t border-gray-200 flex justify-end">
        <Button onClick={handleContactClick} variant="primary" size="large">
          Solicitar Informe Pericial
        </Button>
      </div>
    </ModalBase>
  );
};
